import React from 'react';
import { Bubble, Radio, Button, Dropdown, Icon } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import FeedsEditbox from '@/pages/opinion/pages/feeds/components/FeedsEditbox/index';
import { useIntl } from 'umi';
import useFeedsUpdate from '../../hooks/useFeedsUpdate';
import './index.scss';
import BubbleCommon, { commonValidationTips } from '../BubbleCommon';
import { useValid } from '../ReviewsModal/useValid';
import { getLogValue } from '@op/pages/feeds/hooks/useFeedsRequest';
import { ValidType } from '@op/types/common';

export default function ValidDropdown({
  validLoading,
  type = 'common',
  data,
  needRequest = true,
  logCommentMap,
}: {
  type?: 'common' | 'news';
  validLoading?: boolean;
  data: any;
  needRequest: boolean;
  logCommentMap?: any;
}) {
  const { formatMessage } = useIntl();

  const { filter, changeNewValid, newValid } = useValid({
    data,
    realValue: getLogValue(logCommentMap, data, 'latest_valid') as any,
    needRequest,
    type,
  });

  const {
    logLoading,
    loading,
    submit,
    setNewValue,
    newValue,
    logList,
    getLogList,
  } = useFeedsUpdate({
    defaultValue: newValid,
    oldValue: newValid,
    autoLoad: false,
    filter,
  });

  // valid浮层
  const getValidation = (validation: ValidType) => {
    // 1 Medium 2 High 3 Low 0 Invalid
    if (validation == '1') return 'Medium';
    else if (validation == '2') return 'High';
    else if (validation == '3') return 'Low';
    else return 'Invalid';
  };

  // 编辑Validation下拉框
  const ValidEditBox = (close: any) => (
    <FeedsEditbox
      bd={
        <>
          <span className="feeds-editbox-title">
            {formatMessage({ id: 'Vaildation Editing' })}
            <BubbleCommon
              placement="top"
              iconStyle={{ marginLeft: 6 }}
              tipsMap={commonValidationTips}
            ></BubbleCommon>
          </span>
          <div className="feeds-editbox-radiobox">
            <Radio.Group
              value={String(newValue)}
              onChange={(value: any) => {
                setNewValue(value);
              }}
            >
              <Radio name="2">{formatMessage({ id: 'High' })}</Radio>
              <Radio name="1">{formatMessage({ id: 'Medium' })}</Radio>
              <Radio name="3">{formatMessage({ id: 'Low' })}</Radio>
              <Radio name="0">{formatMessage({ id: 'Invalid' })}</Radio>
            </Radio.Group>
          </div>
          <span className="feeds-editbox-title">
            {formatMessage({ id: 'Editing History' })}
          </span>

          <div className="feeds-editbox-history">
            {logLoading ? (
              <div style={{ textAlign: 'center' }}>
                <Icon type="loading" />
              </div>
            ) : logList.length === 0 ? (
              <div style={{ textAlign: 'center' }}>
                {formatMessage({ id: 'Not yet edited' })}
              </div>
            ) : (
              logList.map(({ new_value, editor, create_time }, index) => {
                return (
                  <div key={create_time} className="editbox-item">
                    <span className="editbox-item-infobox">
                      <span className="editbox-item-info">
                        {formatMessage({ id: getValidation(new_value) })}
                      </span>
                    </span>
                    <span className="editbox-item-name">{editor}</span>
                    <span className="editbox-item-text">{create_time}</span>
                  </div>
                );
              })
            )}
          </div>
        </>
      }
      ft={
        <>
          <Bubble
            dark
            closeOnScroll
            content={
              String(newValue) === String(newValid)
                ? formatMessage({
                    id: 'Please modify before submitting',
                  })
                : !newValue
                ? formatMessage({ id: 'Please select an option' })
                : undefined
            }
          >
            <Button
              onClick={() => {
                submit(close);
                changeNewValid(newValue);
              }}
              type="primary"
              disabled={String(newValue) === String(newValid)}
              loading={loading}
            >
              {formatMessage({ id: 'Confirm' })}
            </Button>
          </Bubble>
          <Button type="weak" disabled={loading} onClick={close}>
            {formatMessage({ id: 'Cancel' })}
          </Button>
        </>
      }
    />
  );

  return (
    <Dropdown
      button={
        <div className="dbo-vailddropdown">
          {validLoading ? (
            <Icon type={'loading'} className="dbo-title-flex-icon" />
          ) : (
            <>
              <span>{formatMessage({ id: getValidation(newValid) })}</span>
              <SvgIcon type="arrow-down" />
            </>
          )}
        </div>
      }
      onOpen={getLogList}
      appearance="pure"
      clickClose={false}
    >
      {(close) => ValidEditBox(close)}
    </Dropdown>
  );
}
